<div class="d-flex h-100" style="width: 30em;max-height: 25rem; min-height: 20rem;">
  <div style="width: 35%;" class="h-100">
    <div class="mat-datetimepickerT2-calendar-header h-100 cal-header">
      <!-- <div (click)="_yearClicked()" *ngIf="type !== 'time'"
        [class.active]="currentView === 'year' || currentView === 'multi-year'"
        class="mat-datetimepickerT2-calendar-header-year" role="button">{{ _yearLabel }}
        <mat-icon *ngIf="multiYearSelector || type === 'year'">arrow_drop_down</mat-icon>
      </div> -->

      <div class="mat-datetimepickerT2-calendar-header-date-time">
        <div *ngIf="type !== 'time' && type !== 'year'" class="mat-datetimepickerT2-calendar-header-date active"
          role="button">
          <!-- {{_dateLabel }} -->
          <div class="monthLabel" [class.active]="currentView === 'year'" (click)="_monthClicked()">
            {{_getMonth}}
          </div>
          <div class="dateLabel" [class.active]="currentView === 'month'" (click)="_dateClicked()">
            {{_getDate}}
          </div>
          <div class="yearLabel" [class.active]="currentView === 'year' || currentView === 'multi-year'"
            (click)="_yearClicked()">
            {{_getYear}}
          </div>
          <!-- (click)="_hoursClicked()" -->
          <div class="timeLabel" [class.active]="currentView === 'clock'" *ngIf="type.endsWith('time')">
            {{_getTime}}
          </div>
        </div>
        <!-- <span *ngIf="type.endsWith('time')"  [class.active]="currentView === 'clock'"
          class="mat-datetimepickerT2-calendar-header-time">
          <span (click)="_hoursClicked()" [class.active]="_clockView == 'hour'"
            class="mat-datetimepickerT2-calendar-header-hours" role="button">{{ _hoursLabel }}</span>:<span
            (click)="_minutesClicked()" [class.active]="_clockView == 'minute'"
            class="mat-datetimepickerT2-calendar-header-minutes" role="button">{{ _minutesLabel }}</span>
          <br />
          <span *ngIf="twelvehour" class="mat-datetimepickerT2-calendar-header-ampm-container">
            <span (click)="_ampmClicked('AM')" [class.active]="_AMPM === 'AM'"
              class="mat-datetimepickerT2-calendar-header-ampm">AM</span>/<span (click)="_ampmClicked('PM')"
              [class.active]="_AMPM === 'PM'" class="mat-datetimepickerT2-calendar-header-ampm">PM</span>
          </span>
        </span> -->
      </div>
    </div>
  </div>
  <div style="width: 65%;">
    <div [ngSwitch]="currentView" class="mat-datetimepickerT2-calendar-content">
      <div *ngIf="currentView === 'month' || currentView === 'year' || currentView === 'multi-year'"
        class="mat-month-content">
        <div class="mat-datetimepickerT2-calendar-controls">
          <div (click)="_previousClicked()" [attr.aria-disabled]="!_previousEnabled()"
            [attr.aria-label]="_ariaLabelPrev" [class.disabled]="!_previousEnabled()"
            class="mat-datetimepickerT2-calendar-previous-button" role="button">
            <svg height="24" viewBox="0 0 24 24" width="24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </div>
          <div (@slideCalendar.done)="_calendarStateDone()" [@slideCalendar]="_calendarState"
            class="mat-datetimepickerT2-calendar-period-button" (click)="_monthYearLabelClick()">
            <strong>{{ _monthYearLabel }} <div class="mat-calendar-arrow"
                [ngClass]="currentView=='multi-year' ? 'invertArrow' : ''"></div> </strong>
          </div>
          <div (click)="_nextClicked()" [attr.aria-disabled]="!_nextEnabled()" [attr.aria-label]="_ariaLabelNext"
            [class.disabled]="!_nextEnabled()" class="mat-datetimepickerT2-calendar-next-button" role="button">
            <svg height="24" viewBox="0 0 24 24" width="24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </div>
        </div>
      </div>
      <mat-datetimepickerT2-month-view (_userSelection)="_userSelected()" (selectedChange)="_dateSelected($event)"
        *ngSwitchCase="'month'" [activeDate]="_activeDate" [dateFilter]="_dateFilterForViews" [selected]="selected"
        [type]="type">
      </mat-datetimepickerT2-month-view>
      <mat-datetimepickerT2-year-view (_userSelection)="_userSelected()" (selectedChange)="_monthSelected($event)"
        *ngSwitchCase="'year'" [activeDate]="_activeDate" [dateFilter]="_dateFilterForViews" [selected]="selected"
        [type]="type">
      </mat-datetimepickerT2-year-view>
      <mat-datetimepickerT2-multi-year-view (_userSelection)="_userSelected()" (selectedChange)="_yearSelected($event)"
        *ngSwitchCase="'multi-year'" [activeDate]="_activeDate" [dateFilter]="_dateFilterForViews" [maxDate]="maxDate"
        [minDate]="minDate" [selected]="selected" [type]="type">
      </mat-datetimepickerT2-multi-year-view>

      <ng-container *ngSwitchDefault>
        <mat-datetimepickerT2-clock (_userSelection)="_userSelected()" (activeDateChange)="_onActiveDateChange($event)"
          (selectedChange)="_timeSelected($event)" [dateFilter]="dateFilter" [interval]="timeInterval"
          [maxDate]="maxDate" [minDate]="minDate" [selected]="_activeDate" [startView]="_clockView"
          [twelvehour]="twelvehour">
        </mat-datetimepickerT2-clock>
        <div class="text-center">
          <mat-button-toggle-group (click)="_ampmClicked(_AMPM)" [(ngModel)]="_AMPM">
            <mat-button-toggle value="AM">AM</mat-button-toggle>
            <mat-button-toggle value="PM">PM</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </ng-container>
    </div>
    <div class="text-center mt-2">
      <div class="btn-group">
        <select class="cust-select btn btn-sm" id="hour" (change)="setTime()">
          <option [value]="item.value" *ngFor="let item of _hours" [disabled]="!item.enabled">
            {{item.displayValue > 9 ? item.displayValue : '0'+item.displayValue}}
          </option>
        </select>

        <select class="cust-select btn btn-sm" id="minute" (change)="setTime()">
          <option *ngFor="let item of _minutes" [value]="item.value" [disabled]="!item.enabled">
            {{item.displayValue > 9 ? item.displayValue : '0'+item.displayValue}}
          </option>
        </select>

        <button type="button" class="btn btn-sm btn-meridian" (click)="_ampmClicked('AM')"
          [ngClass]="{'active-meridian': _AMPM == 'AM'}">AM</button>
        <button type="button" class="btn btn-sm btn-meridian" (click)="_ampmClicked('PM')"
          [ngClass]="{'active-meridian': _AMPM == 'PM'}">PM</button>
      </div>
      <!-- <select class="form-select" aria-label="Default select example">
          <option selected></option>
          <option value="1" *ngFor="let item of minutes">One</option>
        </select> -->

      <!-- <select class="form-select" aria-label="Default select example">
          <option selected></option>
          <option value="1" *ngFor="let item of meridian">One</option>
        </select> -->
    </div>
    <div class="text-right mx-2 my-2" (click)="_apply()">
      <button class="btn btn-sm w-100 apply-btn">Apply</button>
    </div>

  </div>
</div>
